<template>
  <div>
    <el-input
      type="text"
      @click.native="addCLassForStu"
      v-model="this.teacherName"
      placeholder="请选择老师"
      :disabled="doWhat == 'view'"
    ></el-input>

   
     <!-- <el-button type="primary" :disabled="doWhat === 'view'" @click.native="addCLassForStu" size="mini">请选择</el-button> -->
      <!-- <span  :disabled="doWhat == 'view'" style="width:200px">{{teacherName}}</span> -->
    <Modal v-model="modalShow" width="760" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>
          <slot></slot>
        </span>
      </p>

      <queryTeacherBar @teacherResult="queryHandle" />
      <div>
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          @current-change="handleSelect"
          class="elTable"
        >
          <el-table-column label width="80" align="center">
            <template slot-scope="scope">
              <el-radio
                :label="scope.row.id"
                v-model="tempRadio"
                type="selection"
                >{{ "" }}</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="id" label="老师ID" align="center" width="90">
            <template slot-scope="scope">
              <a href="javascript:;" style="color: #1d90e6">{{
                scope.row.id
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="老师"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <a href="javascript:;" style="color: #1d90e6">{{
                scope.row.name
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="office"
            label="职务"
            align="center"
            min-width="100"
          ></el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 300px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import queryTeacherBar from "./queryTeacherBar";
export default {
  name: "teacherSelect",
  components: { queryTeacherBar },
  data() {
    return {
      modalShow: false,
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      loading: true,
      queryTerms: null,
      tempRadio: "",
      name: "",
      phone: "",
      office: "",
      id: "",
      multipleSelection: {},
      teacherName: "",
      doWhat: ""
    };
  },
  props: {
    oldClass: {
      type: Number,
      default: null,
    },
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    len: {
      type: Number,
      default: 1,
    },
    mainTeacherName: {
      type: [String, Array],
      default: "",
    }
  },
  created() {
    // console.log(this.$route.query, 'asndkdnasdjasdhjksadjk')
    if (this.$route.query.do != undefined) {
      this.doWhat = this.$route.query.do;
    }
  },
  watch: {
    mainTeacherName: {
      handler: function(va) {
        if (va) {
            //  debugger
          if (Array.isArray(va)) {
            // debugger
            this.teacherName = va.teacherName;
            return
          }
          this.teacherName = va;
        }
      },
      deep: true,
      immediate: true,
    }
    
  },
  methods: {
    addCLassForStu() {
       this.tempRadio = '' 
      if (this.doWhat != "view") {
        if (this.len > 0) {
          this.modalShow = true;
          this.fetchClassList();
        } else {
          alert("请先选择学生");
          return;
        }
      }
    },
    fetchClassList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      if (this.queryTerms != null) {
        if (this.queryTerms.name != "") {
          params.name = this.queryTerms.name;
        }
         if (this.queryTerms.office != "") {
          params.office = this.queryTerms.office;
        }
      }
      
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchClassList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchClassList();
    },
    modalConfirm() {
      console.log(this.multipleSelection, 'dasd');
      this.teacherName = this.multipleSelection && this.multipleSelection.name;
      this.$emit("teacherResult", this.multipleSelection);
      this.modalShow = false;
    },
    modalCancel() {
      this.modalShow = false;
    },
    queryHandle(param) {
      //点击搜索
      // debugger

      console.log(param);
      this.queryTerms = param;
      this.queryParams.page = 1
      this.fetchClassList();
    },
    handleSelect(val) {
      console.log(val, 'ss')
      // debugger

      this.multipleSelection = val;
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// teacherSelect.vue?04cb61da